module.exports = __webpack_public_path__ + "lp/img/recording_dark_stop.4465f348.svg";